/**
 * Curated example questions, shown under the hero field and in the
 * "we didn't understand" empty state.
 *
 * Hand-written rather than generated: their job is to teach the shape of a good
 * question (an age, a taste, a reservation) in three examples, and they are the
 * first thing a visitor reads about the feature. Keep them short, French, and
 * answerable from the catalogue.
 */
export const NL_SEARCH_SUGGESTIONS: string[] = [
  "Un film d'animaux pour 6 ans, pas trop effrayant",
  "Une série drôle à regarder en famille",
  "Un jeu calme et créatif pour 10 ans",
]
